import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { WHITE_COLOR } from '@/styles';

const Container = styled.div`
  margin-top: 1rem;
  width: 100%;

  &:not(:first-child) {
    background-color: #f5f7fa;
    padding: 12px;
    border-radius: 16px;
    margin-top: 16px;
  }
`;

const TINFieldInputStyleOverrides = css`
  background-color: ${WHITE_COLOR};
  padding-right: 48px;
`;

const TooltipStyleOverrides = css`
  z-index: 1;
  max-width: 280px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  background: ${WHITE_COLOR};
  border: none;
  right: 50px;
  top: -20px;
  /* Shift the entire arrow container */
  &::before {
    background: ${WHITE_COLOR};
    transform: rotate(135deg);
    border: none;
    top: 44px;
    right: -5px;
  }
`;

const TINFieldTooltipWrapper = styled.div`
  position: relative;
`;

const AdditionalTaxResidencyTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 8px 0 16px 4px;
`;

const NoTaxIdReasonStyleOverrides = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const InfoIconButton = styled.button`
  position: absolute;
  right: 12px;
  top: calc(28px - 7px);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 2;
`;

export {
  Container,
  TINFieldInputStyleOverrides,
  TINFieldTooltipWrapper,
  InfoIconButton,
  TooltipStyleOverrides,
  NoTaxIdReasonStyleOverrides,
  AdditionalTaxResidencyTitle,
};
